module.exports = __webpack_public_path__ + "static/img/landing-share-paid.197588b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-share-paid.png
// module id = 1468
// module chunks = 180